import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  viewChild,
} from '@angular/core';

import {
  PayuCardNumberWidgetComponent,
  PrimengButtonDirective,
} from '@web/shared/ui';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-public-checkout-recurrence-payment',
  imports: [PayuCardNumberWidgetComponent, Button, PrimengButtonDirective],
  templateUrl: './public-checkout-recurrence-payment.component.html',
  styleUrl: './public-checkout-recurrence-payment.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicCheckoutRecurrencePaymentComponent {
  public readonly withCenteredButton = input<boolean>(false);
  public readonly withSubmitButton = input<boolean>(true);
  public readonly withTermsAndConditions = input<boolean>(true);
  public readonly withPrivacyPolicy = input<boolean>(true);
  public readonly tokenizeSuccessEvent = output<string>();

  /* prettier-ignore */
  public readonly widgetComponentRef = viewChild.required(PayuCardNumberWidgetComponent);

  public handleSubmitClick(): void {
    this.widgetComponentRef()?.tokenize();
  }

  public handleTokenizeSuccessEvent(token: string): void {
    this.tokenizeSuccessEvent.emit(token);
  }
}
